import UserProfile from './UserProfile'
import Company from './Company'

export default class User {
  constructor() {
    this.name = ''
    this.surname = ''
    this.email = ''
    this.username = ''
    this.password = ''
    this.roles = []
    this.abilities = []
    this.active = false
    this.password_changed = null
    this.profile = new UserProfile
    this.primary_company = new Company
  }
}
